// import { getCurrentEmailsFromLocalStorage, setCurrentEmailsInLocalStorage } from "helpers/sf_utils"
import {
  GET_EMAIL_EVENTS,
  GET_EMAIL_EVENTS_SUCCESS,
  GET_EMAIL_EVENTS_ERROR,
  GET_EMAIL_TEMPLATE_BY_ID,
  GET_EMAIL_TEMPLATE_BY_ID_SUCCESS,
  GET_EMAIL_TEMPLATE_BY_ID_ERROR,
  RESET_EMAIL_TEMPLATE_BY_ID,
  CHECK_EMAIL_STATUS_BY_EVENT,
  CHECK_EMAIL_STATUS_BY_EVENT_SUCCESS,
  CHECK_EMAIL_STATUS_BY_EVENT_ERROR,
  DELETE_EMAIL_STATUS_BY_EVENT,
  DELETE_EMAIL_STATUS_BY_EVENT_SUCCESS,
  DELETE_EMAIL_STATUS_BY_EVENT_ERROR
} from "./actionTypes"
import { buildPaginationCacheKey } from "helpers/sf_utils"

const INIT_STATE = {
  email_events: [],
  error: null,
  loading: false,
  last_page_fetched: 0,
  last_fetched_at: null,
  total_number_of_pages: 0,
  has_next_page: false,
  has_lookahead_pages: false,
  active_cache_key: null,
  page_cache: {},
  email_templates_error: null,
  email_templates_loading: false,
  email_templates: null,
  category_options: [],
  event_options: [],
  email_event_status: [],
  email_event_status_loading: false,
  email_event_status_error: null,
}
const EmailEvents = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_EMAIL_EVENTS:
      let page_number = 1
      const appendResults = Boolean(action.payload?.appendResults)
      if (action.paginated) {
        page_number = action.payload?.queryParams?.page_number
      }
      const useCache = Boolean(action.payload?.useCache)
      const queryParams = action.payload?.queryParams || {}
      const cacheKey = useCache ? buildPaginationCacheKey(queryParams) : null
      const shouldResetCache =
        useCache &&
        page_number === 1 &&
        !appendResults &&
        state.active_cache_key &&
        state.active_cache_key !== cacheKey
      const cachedPage = useCache ? state.page_cache?.[cacheKey]?.[page_number] : null
      return {
        ...state,
        error: null,
        active_cache_key: useCache ? cacheKey : null,
        loading: !cachedPage,
        email_events: cachedPage?.rows || ((page_number === 1 || !appendResults) ? [] : state.email_events),
        last_page_fetched: cachedPage?.page_number || state.last_page_fetched,
        total_number_of_pages: cachedPage?.total_number_of_pages || state.total_number_of_pages,
        has_next_page: typeof cachedPage?.has_next_page === 'boolean' ? cachedPage.has_next_page : state.has_next_page,
        has_lookahead_pages: typeof cachedPage?.has_lookahead_pages === 'boolean' ? cachedPage.has_lookahead_pages : state.has_lookahead_pages,
        page_cache: shouldResetCache ? {} : state.page_cache,
      }

    case GET_EMAIL_EVENTS_SUCCESS:
      let uniqueEmailEvents = [];
      const appendEmailEvents = Boolean(action.meta?.appendResults);
      const rows = Array.isArray(action.payload.data) ? action.payload.data : []
      const all_email_events = appendEmailEvents ? [...state.email_events, ...rows] : rows
      const useCacheForSuccess = Boolean(action.meta?.useCache)
      const successQueryParams = action.meta?.queryParams || {}
      const successCacheKey = useCacheForSuccess ? buildPaginationCacheKey(successQueryParams) : null
      const safePage = parseInt(action.payload.additional_data?.page_number, 10) || 1
      const safeTotal = parseInt(action.payload.additional_data?.total_number_of_pages, 10) || 0
      const pageSnapshot = {
        rows,
        page_number: safePage,
        total_number_of_pages: safeTotal,
        has_next_page: action.payload.additional_data?.has_next_page || false,
        has_lookahead_pages: action.payload.additional_data?.has_lookahead_pages || false,
      }
      all_email_events.forEach(function (item) {
        const i = uniqueEmailEvents.findIndex(x => x.id == item.id);
        if (i <= -1) {
          uniqueEmailEvents.push(item);
        }
      });
      return {
        ...state,
        error: null,
        active_cache_key: useCacheForSuccess ? successCacheKey : state.active_cache_key,
        email_events: uniqueEmailEvents,
        loading: false,
        last_fetched_at: new Date(),
        last_page_fetched: safePage,
        total_number_of_pages: safeTotal,
        has_next_page: action.payload.additional_data?.has_next_page || false,
        has_lookahead_pages: action.payload.additional_data?.has_lookahead_pages || false,
        category_options: action.payload.additional_data?.category_options,
        event_options: action.payload.additional_data?.event_options,
        page_cache: useCacheForSuccess ? {
          ...state.page_cache,
          [successCacheKey]: {
            ...(state.page_cache?.[successCacheKey] || {}),
            [safePage]: pageSnapshot,
          },
        } : state.page_cache,
      }

    case GET_EMAIL_EVENTS_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false,
        has_next_page: false,
        has_lookahead_pages: false,
      }

    case GET_EMAIL_TEMPLATE_BY_ID:
      return {
        ...state,
        email_templates_error: null,
        email_templates_loading: true,
      }

    case GET_EMAIL_TEMPLATE_BY_ID_SUCCESS:
      return {
        ...state,
        email_templates_error: null,
        email_templates: { ...action.payload.data },
        email_templates_loading: false,
      }

    case GET_EMAIL_TEMPLATE_BY_ID_ERROR:
      return {
        ...state,
        email_templates_error: action.payload,
        email_templates_loading: false,
      }

    case CHECK_EMAIL_STATUS_BY_EVENT:
      return {
        ...state,
        email_event_status_error: null,
        email_event_status_loading: true,
      }

    case CHECK_EMAIL_STATUS_BY_EVENT_SUCCESS:
      return {
        ...state,
        email_event_status_error: null,
        email_event_status: action.payload,
        email_event_status_loading: false,
      }

    case CHECK_EMAIL_STATUS_BY_EVENT_ERROR:
      return {
        ...state,
        email_event_status_error: action.payload,
        email_event_status_loading: false,
      }

    case DELETE_EMAIL_STATUS_BY_EVENT:
      return {
        ...state,
        email_event_status_error: null,
        email_event_status_loading: true,
      }

    case DELETE_EMAIL_STATUS_BY_EVENT_SUCCESS:
      return {
        ...state,
        email_event_status_error: null,
        email_event_status: state.email_event_status.map(event => {
          if (event.email !== action.payload.email) {
            return event;
          }
          return {
            ...event,
            [action.payload.event.replace(/s$/, "")]: false
          }
        })
        ,
        email_event_status_loading: false,
      }

    case DELETE_EMAIL_STATUS_BY_EVENT_ERROR:
      return {
        ...state,
        email_event_status_error: action.payload,
        email_event_status_loading: false,
      }

    case RESET_EMAIL_TEMPLATE_BY_ID:
      return {
        ...state,
        email_templates_error: null,
        email_templates: null,
        email_templates_loading: false,
      }

    default:
      return state
  }
}

export default EmailEvents
